import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'
import { useDealerships } from '@/api/hooks/useDealerships'
import DealershipDetails from '@/components/organisms/dealership-details'
import { useMyWorkshops } from '@/hooks/useMyWorkshops'

const searchSchema = z.object({
  workshopId: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/dealership/$dealershipId')({
  validateSearch: searchSchema,
  component: DealershipDetailsRoute,
})

function DealershipDetailsRoute() {
  const { dealershipId } = Route.useParams()
  const { workshopId: workshopIdParam } = Route.useSearch()
  const { selectedWorkshopId } = useMyWorkshops()
  const workshopId = workshopIdParam ?? selectedWorkshopId
  const { data: dealerships } = useDealerships(workshopId ?? '')
  const dealership = dealerships.find(d => d.id === dealershipId)

  if (!dealership || !workshopId) return null

  return <DealershipDetails key={dealership.id} dealership={dealership} workshopId={workshopId} />
}
